import type {ISurveyRange} from "../../types/IBuildSurveyParams";
import {parseToNumber} from "./parse_to_number";

/**
 * Calculates price based on all sources.
 * - Takes the maximum price from all available sources
 * - Adds 10% margin
 * - Rounds up to nearest 50000
 * - When survey exists and property/offer is cheaper (or null), keeps survey price only if no filters exceed it
 */
export const surveyCalculatePrice = (
    surveyPrice: ISurveyRange<number | null> | undefined,
    propertyPrice: number | null | undefined,
    offerPriceMax: number | null | undefined,
    filterPrice: string | null | undefined,
    hasSurvey: boolean
): ISurveyRange<number | null> => {
    const prices: number[] = [];

    if (surveyPrice?.upper) {
        prices.push(surveyPrice.upper);
    }

    if (propertyPrice) {
        prices.push(propertyPrice);
    }

    if (offerPriceMax) {
        prices.push(offerPriceMax);
    }

    const filterPriceValue = parseToNumber(filterPrice);

    if (filterPriceValue) {
        prices.push(filterPriceValue);
    }

    const hasNoPrices = prices.length === 0;
    if (hasNoPrices) {
        return surveyPrice || {lower: 0, upper: null, bounds: "[]"};
    }

    const maxPrice = Math.max(...prices);

    // Get the max price excluding survey (only from details, offer, and filters)
    const externalPrices: number[] = [];

    if (propertyPrice) {
        externalPrices.push(propertyPrice);
    }

    if (offerPriceMax !== null && offerPriceMax !== undefined) {
        externalPrices.push(offerPriceMax);
    }

    if (filterPriceValue) {
        externalPrices.push(filterPriceValue);
    }

    const maxExternalPrice = externalPrices.length > 0 ? Math.max(...externalPrices) : 0;

    // If survey exists and no external source exceeds survey price, keep survey price unchanged
    if (hasSurvey && surveyPrice?.upper !== null && surveyPrice?.upper !== undefined) {
        if (maxExternalPrice <= surveyPrice.upper) {
            return surveyPrice;
        }
    }

    // Calculate price rounded to nearest 5k
    const roundedPrice = Math.ceil(maxPrice / 5000) * 5000;

    return {
        lower: surveyPrice?.lower ?? 0,
        upper: roundedPrice,
        bounds: surveyPrice?.bounds ?? "[]"
    };
};
import type {ISurveyRange} from "../../types/IBuildSurveyParams";
import {parseToNumber} from "./parse_to_number";

/**
 * Calculates price based on all sources.
 * - Takes the maximum price from all available sources
 * - Adds 10% margin
 * - Rounds up to nearest 50000
 * - When survey exists and property/offer is cheaper (or null), keeps survey price only if no filters exceed it
 */
export const surveyCalculatePrice = (
    surveyPrice: ISurveyRange<number | null> | undefined,
    propertyPrice: number | null | undefined,
    offerPriceMax: number | null | undefined,
    filterPrice: string | null | undefined,
    hasSurvey: boolean
): ISurveyRange<number | null> => {
    const prices: number[] = [];

    if (surveyPrice?.upper) {
        prices.push(surveyPrice.upper);
    }

    if (propertyPrice) {
        prices.push(propertyPrice);
    }

    if (offerPriceMax) {
        prices.push(offerPriceMax);
    }

    const filterPriceValue = parseToNumber(filterPrice);

    if (filterPriceValue) {
        prices.push(filterPriceValue);
    }

    const hasNoPrices = prices.length === 0;
    if (hasNoPrices) {
        return surveyPrice || {lower: 0, upper: null, bounds: "[]"};
    }

    const maxPrice = Math.max(...prices);

    // Get the max price excluding survey (only from details, offer, and filters)
    const externalPrices: number[] = [];

    if (propertyPrice) {
        externalPrices.push(propertyPrice);
    }

    if (offerPriceMax !== null && offerPriceMax !== undefined) {
        externalPrices.push(offerPriceMax);
    }

    if (filterPriceValue) {
        externalPrices.push(filterPriceValue);
    }

    const maxExternalPrice = externalPrices.length > 0 ? Math.max(...externalPrices) : 0;

    // If survey exists and no external source exceeds survey price, keep survey price unchanged
    if (hasSurvey && surveyPrice?.upper !== null && surveyPrice?.upper !== undefined) {
        if (maxExternalPrice <= surveyPrice.upper) {
            return surveyPrice;
        }
    }

    // Calculate price rounded to nearest 5k
    const roundedPrice = Math.ceil(maxPrice / 5000) * 5000;

    return {
        lower: surveyPrice?.lower ?? 0,
        upper: roundedPrice,
        bounds: surveyPrice?.bounds ?? "[]"
    };
};
